// extracted by mini-css-extract-plugin
export default {"description":"style_description__lHnO6","fade-in":"style_fade-in__8lgrV","image":"style_image__2WxDf"};